import React, {useMemo} from 'react';
import type {SiteMetadata} from '../../gatsby-config';

const STATIC_NAVS = [
  {
    header: '運営会社',
    items: [
      {
        label: '会社概要',
        url: 'https://kanmu.co.jp',
      },
      {
        label: 'プレスリリース',
        url: 'https://kanmu.co.jp/news/',
      },
      {
        label: '採用情報',
        url: 'https://kanmu.co.jp/jobs/',
      },
      {
        label: 'ポリシー',
        url: 'https://kanmu.co.jp/policies/',
      },
    ],
  },
  {
    header: 'ヘルプ',
    items: [
      {
        label: 'よくあるご質問',
        url: 'https://support.vandle.jp/hc/ja/sections/205632368',
      },
      {
        label: 'サポートデスク',
        url: 'https://support.vandle.jp/',
      },
      {
        label: 'コラム',
        url: 'https://vandle.jp/hello/',
      },
    ],
  },
];

type Props = {
  appStoreUrl: string;
  googlePlayUrl: string;
  siteMetadata: SiteMetadata;
};

/**
 * GlobalFooter
 *
 * @return {React.JSX.Element}
 */
export default function GlobalFooter({
  appStoreUrl,
  googlePlayUrl,
  siteMetadata,
}: Props): React.JSX.Element {
  const navs = useMemo(() => {
    return [
      {
        header: 'バンドルカード',
        items: [
          {
            label: 'ホーム',
            url: '/',
          },
          {
            label: '仕様',
            url: '/specs/',
          },
          {
            label: 'App Store',
            url: appStoreUrl,
          },
          {
            label: 'Google Play',
            url: googlePlayUrl,
          },
        ],
      },
      ...STATIC_NAVS,
    ];
  }, [appStoreUrl, googlePlayUrl]);
  return (
    <div className="GlobalFooter">
      <div className="GlobalFooter_contents">
        {navs.map((navItem, index) => (
          <ul className="GlobalFooter_nav" key={index}>
            <li className="GlobalFooter_nav_item">
              <p className="GlobalFooter_nav_item_header">{navItem.header}</p>
            </li>
            {navItem.items.map((item, itemIndex) => (
              <li className="GlobalFooter_nav_item" key={itemIndex}>
                <a href={item.url}>{item.label}</a>
              </li>
            ))}
          </ul>
        ))}
        <div className="GlobalFooter_havefun">
          <a
            className="GlobalFooter_havefun_anchor"
            href={siteMetadata.twitter}
            rel="noreferrer"
            target="_blank"
          >
            <img
              alt="Facebook"
              className="GlobalFooter_havefun_icon-twitter"
              src="/images/logo/twitter.svg"
            />
          </a>
          <a
            className="GlobalFooter_havefun_anchor"
            href={siteMetadata.facebookPage}
            rel="noreferrer"
            target="_blank"
          >
            <img
              alt="Facebook"
              className="GlobalFooter_havefun_icon-facebook"
              src="/images/logo/facebook.svg"
            />
          </a>
          <a
            className="GlobalFooter_havefun_anchor"
            href={siteMetadata.lineAt}
            rel="noreferrer"
            target="_blank"
          >
            <img
              alt="LINE@"
              className="GlobalFooter_havefun_icon-lineAt"
              src="/images/logo/line_at.png"
            />
          </a>
        </div>
      </div>
      <div className="GlobalFooter_footer">
        <ul className="GlobalFooter_footer_nav">
          <li className="GlobalFooter_footer_nav_item">
            <a href="/terms/">利用規約</a>
          </li>
          <li className="GlobalFooter_footer_nav_item">
            <a href="/privacy-policy/">プライバシーポリシー</a>
          </li>
          <li className="GlobalFooter_footer_nav_item">
            <a href="/settlement/">資金決済法に基づく表示</a>
          </li>
          <li className="GlobalFooter_footer_nav_item">
            <a href="/antisocial/">反社会勢力への対応基本方針</a>
          </li>
          <li className="GlobalFooter_footer_nav_item">
            <a href="https://kanmu.co.jp">運営会社</a>
          </li>
        </ul>
        <div className="GlobalFooter_footer_desc">
          <div className="GlobalFooter_footer_desc_main">
            <div className="GlobalFooter_footer_desc_main_banner">
              <a href={appStoreUrl}>
                <img
                  alt="AppStoreからダウンロード"
                  height="44"
                  src="/images/logo/app_store_badge.png"
                />
              </a>
              <a href={googlePlayUrl}>
                <img
                  alt="Google Playで手に入れよう"
                  height="44"
                  src="/images/logo/google_play_badge.png"
                />
              </a>
              <img
                alt="QRコードでダウンロード"
                className="GlobalFooter_footer_desc_main_banner_qr"
                height="48"
                src="/images/material/download-qr-code.svg"
              />
            </div>
            <div className="GlobalFooter_footer_desc_main_catchphrase">
              <p className="GlobalFooter_footer_desc_main_catchphrase_body">
                VANDLE CARD [バンドルカード] - これまでにないカード体験を。
              </p>
              <p className="GlobalFooter_footer_desc_main_catchphrase_caption">
                ダウンロードして1分ですぐ使える
              </p>
            </div>
          </div>
          <p className="GlobalFooter_footer_desc_copyright">
            © 2016-{new Date().getFullYear()} Kanmu, Inc.
          </p>
        </div>
      </div>
    </div>
  );
}
